// fetchdirectActions.js


import {
  SET_ALL_CART_DATA,
  SET_ALL_METACART_DATA,
  SET_IPSNOTICE_DATA,
  SET_IPSPRODUCT_DATA
} from './shoppingcartActions';

export const setAllCartData = (cartData) => {
  // Speichern der Daten im Local Storage
  if (cartData) {
   // SidecartControl.saveCartToLocalStorage({ cartItems: cartData, supportsHTML5Storage });
  }
  
  return {
    type: SET_ALL_CART_DATA,
    payload: cartData
  };
};

export const setMetacartData = (metacartdata) => ({
  type: SET_ALL_METACART_DATA,
  payload: metacartdata
});

export const setIPSNoticeData = (noticedata) => ({
  type: SET_IPSNOTICE_DATA,
  payload: noticedata
});

export const setIPSProductData = (productdata) => ({
  type: SET_IPSPRODUCT_DATA,
  payload: productdata
});